exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#green-background {\n  margin-left: 12px;\n  background-color: green;\n  padding: 10px;\n  color: white;\n  width: 72px; }\n\n#red-background {\n  margin-left: 12px;\n  background-color: red;\n  padding: 10px;\n  color: white;\n  width: 57px; }\n\n.success {\n  background-color: green;\n  padding: 1%;\n  color: white;\n  margin: 1%;\n  border-radius: 7%; }\n\n.failed {\n  background-color: red;\n  padding: 1%;\n  color: white;\n  margin: 1%;\n  border-radius: 7%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-audit-log/solution-description-audit-log.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-audit-log/solution-description-audit-log.component.scss
// module chunks = main